// src/plugins/vuetify.js

import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      // options: { customProperties: true },
      light: {
        primary: colors.blueGrey.base,
        secondary: colors.green.lighten1,
        accent: colors.indigo.lighten1,
        aside: colors.blueGrey.lighten5,
        highlight: colors.yellow.lighten5,
      },
    },
  },
})
